import { FadeUp, SectionHeading } from "../components/motion";

export default function Welcome() {
  return (
    <section id="welcome" data-testid="section-welcome" className="bg-parchment py-20 sm:py-24">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <SectionHeading eyebrow="Who Is Welcome?" titleLines={["Who is welcome?"]} tone="light-bg" />
        <FadeUp delay={0.2}>
          <p className="mt-8 text-base font-light leading-relaxed text-navy/85 sm:text-lg" data-testid="welcome-copy">
            Whether you currently serve as a chaplain or are curious about this path of service,
            you are welcome. Chaplain at Sea offers space to rest, connect with experienced
            chaplains, and explore your own sense of purpose. No previous chaplaincy experience is
            required.
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
